<template>
    <div class="account pt-6 page-content">
        <div class="columns is-multiline">
        <link-card class="column is-one-quarter-widescreen is-offset-one-quarter-widescreen is-full" router-link="/mail-update">
            E-Mail bearbeiten
        </link-card>
        <link-card class="column is-one-quarter-widescreen is-full" router-link="/password-update">
            Passwort bearbeiten
        </link-card>
        <link-card class="column is-half-widescreen is-offset-one-quarter-widescreen is-full" router-link="/profile-update">
            Kundendaten bearbeiten
        </link-card></div>
        <div class="columns">
            <OrdersList class="column is-full is-half-widescreen is-offset-one-quarter-widescreen"></OrdersList>
        </div>
    </div>
</template>

<script>
    import OrdersList from "./OrdersList";
    import LinkCard from "../shared/LinkCard";

    export default {
        name: "Account",
        components: {LinkCard,  OrdersList},
        created() {
            if (!this.isUserLoggedIn) {
                this.$router.push('/login');
            }
            this.$store.dispatch('fetchCMSPage', {urlSlug: "/"});
        },
        computed:{
            isUserLoggedIn(){
                return this.$store.getters.isUserLoggedIn;
            }
        }
    }
</script>

<style scoped>

</style>